import { DrawerForm } from '@ant-design/pro-components';
import PropTypes from 'prop-types';
import MarkdownContent from '@/common/components/MarkdownContent';

const renderMarkdownDetail = (value) => <MarkdownContent>{value || ''}</MarkdownContent>;

const HotRadarDetailDrawer = ({ onClose, open, record }) => (
  <DrawerForm
    title="爆款拆解详情"
    open={open}
    onOpenChange={(nextOpen) => {
      if (!nextOpen) {
        onClose();
      }
    }}
    submitter={false}
    width={1024}
  >
    {renderMarkdownDetail(record?.detailDoc)}
  </DrawerForm>
);

HotRadarDetailDrawer.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  record: PropTypes.shape({
    detailDoc: PropTypes.string,
  }),
};

HotRadarDetailDrawer.defaultProps = {
  onClose: () => {},
  open: false,
  record: null,
};

export default HotRadarDetailDrawer;
